// The end of a match, shown over the battlefield it happened on. Like the home
// screen this is an overlay rather than a separate page, so the wreckage stays
// visible behind the verdict.
import React from "react";

const overlay = {
  position: "absolute",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "18px",
  // Unlike the home screen, this sheet does take the mouse: the game is over,
  // and orders clicked through to units that are no longer playing would do
  // nothing but confuse.
  pointerEvents: "auto",
  background:
    "radial-gradient(ellipse at center, rgba(24,20,12,0.78) 0%, rgba(24,20,12,0.55) 60%, rgba(24,20,12,0.4) 100%)",
};

const title = (won) => ({
  margin: 0,
  fontSize: "62px",
  letterSpacing: "5px",
  color: won ? "#f6dd9a" : "#e8b4a4",
  textShadow: "0 3px 0 #4a3418, 0 6px 18px rgba(0,0,0,0.75)",
  fontFamily: "Georgia, 'Times New Roman', serif",
});

const tagline = {
  margin: "0 0 22px",
  color: "#e0cfa4",
  fontSize: "17px",
  letterSpacing: "2px",
  textShadow: "0 2px 6px rgba(0,0,0,0.8)",
};

// Matches the home screen's two tiers, so the buttons that take you to a fresh
// match look the same in both places.
const button = (primary) => ({
  cursor: "pointer",
  width: "330px",
  padding: primary ? "20px 0" : "14px 0",
  fontSize: primary ? "26px" : "18px",
  fontWeight: 700,
  letterSpacing: "2px",
  fontFamily: "Georgia, 'Times New Roman', serif",
  color: primary ? "#2a1c08" : "#f0e2c0",
  background: primary
    ? "linear-gradient(#f5d98a, #d8a441 55%, #b9822b)"
    : "linear-gradient(#6c5836, #4a3b22)",
  border: primary ? "3px solid #7a5518" : "3px solid #33280f",
  borderRadius: "8px",
  boxShadow: "0 5px 0 rgba(0,0,0,0.45), 0 10px 26px rgba(0,0,0,0.5)",
});

// Two ways on from here, the same two the home screen offers and in the same
// order: a fresh match against whoever is waiting, or one against the bots.
const GameOver = ({ won, onVsBots, onPlayOnline }) => (
  <div
    style={overlay}
    // The sheet swallows clicks, and a right click on it would otherwise raise
    // the browser menu the canvas takes pains to suppress.
    onContextMenu={(e) => e.preventDefault()}
  >
    <h1 style={title(won)}>{won ? "YOU WIN!" : "YOU LOSE"}</h1>
    <p style={tagline}>
      {won ? "THE FIELD IS YOURS" : "YOUR CANNONS ARE SILENCED"}
    </p>
    <button style={button(true)} onClick={onPlayOnline}>
      Play Again Online
    </button>
    <button style={button(false)} onClick={onVsBots}>
      Play Again vs Bots
    </button>
  </div>
);

export default GameOver;
